import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import CloseControl from './close';

export default class View extends Component {
  render() {
    return (
      <Card>
        <Card.Header>
          Graph Details
          <span className="float-right">
            <CloseControl shell={this.props.shell} />
          </span>
        </Card.Header>
        <Card.Body>
          <Card.Text as="h6">General</Card.Text>
          <Card.Text>
            <table className="properties">
              {/* These were two hardcoded strings, "graph" and "generic" — the domain/type/format
                  triple this platform no longer has. They survived the blob-type epic because
                  nothing referenced a field to go stale; they were literals describing a model that
                  had been deleted. One row now, reading the blob's actual type. */}
              <tr>
                <td className="prop-name-column">Type</td>
                <td className="prop-value-column"><code>{this.props.blob.type}</code></td>
              </tr>
            </table>
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}
